
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { 
  Plus,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CurrentList } from "../currentList/currentList";
import { HistoryList } from "../historyList/historyList";
import { Summary } from "../summary/summary";

const ReconnectionLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Reconnection Management</h1>
          <p className="text-sm text-muted-foreground mt-1">View, filter and manage reconnections.</p>
        </div>
        <div className="flex gap-2">
        <Button onClick={() => navigate("/cx/reconnections/create")}>
            <Plus className="mr-2 h-4 w-4" />
            Create Reconnection
          </Button>
        </div>
      </div>

      <Summary />

      <div className="flex flex-col space-y-4">
        <div className="w-full overflow-hidden">
        <Tabs 
        defaultValue="current"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        urlMapping={{
          current: "current",
          history: "history",
        }}
        tabComponents={{
          current: {
            label: "Current",
            component: <CurrentList />
          },
          history: {
            label: "History",
            component: <HistoryList />
          }
        }}
      />
        </div>
      </div>
    </div>
  );
};

export default ReconnectionLandingPage;
